<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="等级名称："  label-for="key">
              <Input search enter-button placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
<!--        <Row type="flex">-->
<!--          <Col>-->
<!--            <Button type="primary"  icon="md-add" @click="add">添加会员等级</Button>-->
<!--          </Col>-->
<!--        </Row>-->
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="pic">
          <div class="tabBox_img">
            <img :src="row.pic ? row.pic : require('@/assets/images/avatar.png')">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.level_id)">编辑</a>
<!--          <Divider type="vertical" />-->
<!--          <a @click="del(row,'删除')">删除</a>-->
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!-- 添加编辑-->
    <userLevelEdit :editShow="editShow" :id="level_id" @updateStatusModel="updateStatusModel"></userLevelEdit>
    <!--删除-->
    <modalSure ref="modalSure" title="等级" :confirm="confirm" :id="level_id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { userLevelList, deleteLevel } from '@/api/userLevel'
import userLevelEdit from './components/userLevelEdit'
import modalSure from '@/components/modalSure'
export default {
  name: 'userLevellist',
  components: { userLevelEdit, modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: ''
      },
      modelApi: deleteLevel,
      editShow: false,
      confirm: false,
      dataCount: 0,
      userInfo: [],
      loading: false,
      level_id: 0,
      ids: 0,
      columns2: [
        {
          title: '等级名称',
          key: 'level_name',
          minWidth: 120
        },
        {
          title: '解锁所需分值',
          key: 'level_integral',
          minWidth: 120
        },
        {
          title: '图片',
          slot: 'pic',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.userList()
  },
  methods: {
    userList () {
      this.loading = true
      userLevelList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.userList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.userList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {
      this.level_id = id
      this.editShow = true
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    // 添加
    add () {
      this.editShow = true
    },
    del (row) {
      this.level_id = row.level_id
      this.confirm = true
    },
    closeModal (val) {
      if (val) {
        this.reload()
      }
    }
  }
}
</script>
